import { BlockOutlined } from '@mui/icons-material';
import { Button, CardContent, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import SimpleCard from '../../../../../components/SimpleCard';
import { APP_ROUTES } from '../../../../../constants/app-routes';

export default function Cancelled() {
  const navigate = useNavigate();
  const { currentBooking } = useSelector((store) => store.vendorRetail);

  const handleBackToDashboard = () => {
    navigate(APP_ROUTES.DASHBOARD);
  };

  return (
    <div>
      <Grid container justifyContent="center" marginBottom={2}>
        <Grid item>
          <Typography fontWeight="bold">Booking Cancelled</Typography>
        </Grid>
      </Grid>

      <SimpleCard variant="outlined">
        <CardContent>
          <Grid container justifyContent="center" textAlign="center">
            <Grid item xs={12}>
              <BlockOutlined
                sx={{
                  fontSize: 80,
                  color: '#6C757D',
                  marginBottom: 2,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h5" fontWeight="bold" marginBottom={2}>
                This booking has been cancelled
              </Typography>

              <Typography variant="body1" color="text.secondary" marginBottom={3}>
                This retail space booking is no longer active.
              </Typography>

              {currentBooking && (
                <div style={{ marginBottom: '2rem' }}>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Original Date:</strong>{' '}
                    {moment(currentBooking.booking_date).format('MMM DD, YYYY')}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Time:</strong> {currentBooking.start_time} - {currentBooking.end_time}
                  </Typography>
                  {currentBooking.cancellation_reason && (
                    <Typography variant="body2" color="text.secondary" marginTop={1}>
                      <strong>Reason:</strong> {currentBooking.cancellation_reason}
                    </Typography>
                  )}
                </div>
              )}

              <Typography variant="body2" color="text.secondary" marginBottom={3}>
                If you have any questions about this cancellation or refunds, please contact
                support.
              </Typography>

              <Button
                variant="contained"
                size="large"
                onClick={handleBackToDashboard}
                sx={{
                  bgcolor: '#EE7B57',
                  '&:hover': {
                    bgcolor: '#d66a47',
                  },
                  px: 4,
                  py: 1.5,
                }}>
                Back to Dashboard
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </SimpleCard>
    </div>
  );
}
